import { render, staticRenderFns } from "./NoticeDialog.vue?vue&type=template&id=0dfa87a7"
import script from "./NoticeDialog.vue?vue&type=script&lang=js"
export * from "./NoticeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports